import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from "@angular/core";
import { ActivatedRoute, EventType, NavigationEnd, Router, RouterLink, RouterOutlet } from "@angular/router";
import { IconDefinition, IconProp } from "@fortawesome/fontawesome-svg-core";
import {
    faBook,
    faCaretDown,
    faChevronUp,
    faClock,
    faClockFour,
    faClockRotateLeft,
    faEnvelope,
    faGlobe,
    faHome,
    faInfoCircle,
    faLock,
    faMap,
    faNewspaper,
    faRocket,
    faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import { TrvNgMapService, TrvNgMapOverlayService, MapTools } from "@trafikverket/trv-ng-map";
import {
    NavigationItem,
    RouterNavigationItem,
    TrvModalService,
    TrvPopoverPosition,
    TrvPopoverRef,
    TrvPopoverDirective,
    TrvTooltipDirective,
    TrvGlobalMessagesService,
} from "@trv-hub/trv-ng-common";
import { MapComponent } from "../components/map/map/map.component";
import { NavigationService } from "../service/navigation/navigation.service";
import { environment } from "src/environments/environment";
import { Title } from "@angular/platform-browser";
import { combineLatest, firstValueFrom, forkJoin, of, take } from "rxjs";
import { LocalStorageService } from "../service/local-storage.service";
import { Coordinate } from "ol/coordinate";
import { SWEDEN_VIEW } from "../shared/constants";
import { SvgIcon } from "../shared/utils/svg-helper";
import { mobileMenuStateHeights, NvdbNavigationService } from "../service/nvdb-navigation.service";
import {
    svgPrinter,
    svgHamburger,
    svgArrowLeft,
    svgTrafikverketLogo,
    svgPerson,
    svgLocation,
    svgPlus,
    svgMinus,
    svgArrowDown,
    svgChevronDown,
    svgInfo,
    svgCircleInfo,
    svgNotebookPen,
} from "../shared/utils/svg-helper-data";
import { OidcSecurityService } from "angular-auth-oidc-client";
import TileWMS from "ol/source/TileWMS";
import ImageWMS from "ol/source/ImageWMS";
import Source from "ol/source/Source";
import { ApplicationInfoModalComponent } from "../components/modals/application-info-modal/application-info-modal.component";
import { MapMenuComponent } from "../components/map-menu/map-menu.component";
import { SvgIconComponent } from "../components/utils/svg-icon/svg-icon.component";
import { AsyncPipe, NgClass, NgStyle } from "@angular/common";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { MapExportPreviewModalComponent } from "@components/map-menu/print-map-tab/map-export-preview-modal/map-export-preview-modal.component";
import { NetDbService } from "@app/service/net-db.service";
import { ReleaseNotesComponent } from "@app/components/modals/release-notes/release-notes.component";
import { Language, LanguageService } from "@app/service/language.service";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
    imports: [
        SvgIconComponent,
        RouterOutlet,
        MapMenuComponent,
        FaIconComponent,
        TrvTooltipDirective,
        NgStyle,
        TrvTooltipDirective,
    ]
})
export class DashboardComponent implements AfterViewInit {
    @ViewChild("container", { read: ElementRef, static: false }) container!: ElementRef;
    @ViewChild("resizeHandle", { read: ElementRef, static: false }) resizeHandle!: ElementRef;

    public mouseX = 0;

    public environment = environment;

    public googleMapsApiKey = environment.streetViewApiKey;

    public dropdownOpen = false;

    public fasEnvelope: IconProp = faEnvelope as IconProp;
    public fasLock: IconProp = faLock as IconProp;
    public fasUser: IconProp = faUserCircle as IconProp;
    public fasInfo: IconProp = faInfoCircle as IconProp;
    public faCaretDown: IconProp = faCaretDown as IconProp;
    public faGlobe: IconProp = faGlobe as IconProp;
    public faChevronUp = faChevronUp;
    public faEnvelope = faEnvelope;
    public faNewspaper = faNewspaper;
    public faBook = faBook;
    public faClock = faClock;
    public faRocket = faRocket;

    //Svg icons
    public printerIcon: SvgIcon = svgPrinter;
    public hamburgerIcon: SvgIcon = svgHamburger;
    public arrowLeft: SvgIcon = svgArrowLeft;
    public chevronDown: SvgIcon = svgChevronDown;
    public logoIconWithText: SvgIcon = svgTrafikverketLogo;
    public personIcon: SvgIcon = svgPerson;
    public infoIcon: SvgIcon = svgInfo;
    public infoCircleIcon: SvgIcon = svgCircleInfo;
    public locationIcon: SvgIcon = svgLocation;
    public plusIcon: SvgIcon = svgPlus;
    public minusIcon: SvgIcon = svgMinus;
    public noteBookPenIcon: SvgIcon = svgNotebookPen;

    public email: string = "NVDBpakarta@trafikverket.se";


    public title: string = "NVDB dataleverans";

    @ViewChild(MapMenuComponent) mapmenu!: MapMenuComponent;

    public buildVersion: string = "";

    backText: string = "Tillbaka";

    constructor(
        private route: ActivatedRoute,
        @Inject(Router) private router: Router,
        @Inject(LocalStorageService)
        private localStorageService: LocalStorageService,
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        @Inject(TrvNgMapOverlayService)
        private trvMapOverlayService: TrvNgMapOverlayService,
        @Inject(NvdbNavigationService)
        public nvdbNavigation: NvdbNavigationService,
        @Inject(TrvModalService) public trvModalService: TrvModalService,
        public netDbService: NetDbService,
        public messageService: TrvGlobalMessagesService,
        public lang: LanguageService,
        private cdRef: ChangeDetectorRef
    ) {
        this.buildVersion = environment.buildVersion;

        //Site specific variables,
        let title = "NJDB på webb";
        if (environment.application == "NjdbPåWebb") {
            title = "NJDB på webb";
            this.email = "njdb@trafikverket.se";
        } else if (environment.application == "JNBKarta") {
            title = lang.GetValue("MapMenu.Map");
            this.email = "jnb@trafikverket.se";

        }

        this.nvdbNavigation.siteTitle = title;

        this.nvdbNavigation.currentPageIsMap = /^\/(map)?(\?.*)?$/.test(router.url);
    }


    ngAfterViewInit() {

        this.lang.currentLanguage$.subscribe(() => {
            this.cdRef.detectChanges();
        });

        if (environment.application == "JNBKarta") {
            this.lang.currentLanguage$.subscribe(() => {
              this.nvdbNavigation.siteTitle = this.lang.GetValue("MapMenu.Map");
              this.cdRef.detectChanges();
            });
          }


        if (environment.application == "NjdbPåWebb") {
            this.netDbService
                .getLastFeatureUpdateNVDB()
                .pipe(take(1))
                .subscribe({
                    next: lastFeatureUpdateNVDB => {
                        if (lastFeatureUpdateNVDB) this.nvdbNavigation.formattedLastFeatureUpdateNVDB = lastFeatureUpdateNVDB.split(" ")[0];
                    },
                    error: () => {
                        this.messageService.error("Gick ej att hämta när NJDB senast uppdaterades.");
                        this.nvdbNavigation.loadingformattedLastFeatureUpdateNVDB = false;
                    },
                    complete: () => {
                        this.nvdbNavigation.loadingformattedLastFeatureUpdateNVDB = false;
                    },
                });
        }

        this.trvMapService.onMapLoaded().subscribe(() => {
            //Order datalayers by name
            this.trvMapService.trvMap?.trvLayer.wmsLayerListItems.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });

            //Set simple ruler tool if mobile
            if (this.nvdbNavigation.isMobileDevice) {
                this.trvMapService.trvMap!.trvInteractions.simpleRulerTool = true;
                this.trvMapService.trvMap!.trvInteractions.simplePositionTool = true;
            }
        });

        if (this.nvdbNavigation.isMobileDevice) {
            this.nvdbNavigation.currentMobileMenuState.valueChanges.subscribe(state => { });
        }

        if (this.nvdbNavigation.isMobileDevice) {
            const mobileMenus = document.getElementsByClassName("mobile-menu");
            const mobileMenu = mobileMenus[0] as HTMLElement;

            // Check if menuTabs exists
            if (mobileMenu) {
                // Create a ResizeObserver to listen for changes in height
                const resizeObserver = new ResizeObserver(entries => {
                    for (const entry of entries) {
                        try {
                            const newHeight = entry.contentRect.height;

                            const elements = document.getElementsByClassName("mouse-position-coordinate");
                            const element = elements[0] as HTMLElement;

                            const _mobilectrlbuttons = document.getElementsByClassName("mobile-map-control-btns");
                            const mobilectrlbuttons = _mobilectrlbuttons[0] as HTMLElement;

                            const maps = document.getElementsByClassName("map");
                            const map = maps[0] as HTMLElement;

                            let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

                            const offsetMap = vh - map.getBoundingClientRect().height;
                            const vla = newHeight - offsetMap;
                            element.style.bottom = vla + "px";
                            //mobilectrlbuttons.style.bottom = vla + 45 + "px";
                        } catch (e) {
                            console.log("Error in resizeObserver", e);
                        }
                    }
                });

                resizeObserver.observe(mobileMenu);
            }
        }
    }

    onMouseDown = (event: MouseEvent) => {
        this.mouseX = event.clientX;

        document.body.style.cursor = "col-resize";
        this.container.nativeElement.style.userSelect = "none";
        this.container.nativeElement.style.pointerEvents = "none";
        this.resizeHandle.nativeElement.style.opacity = 100;

        this.resizeHandle.nativeElement.style.opacity = 100;

        document.addEventListener("mousemove", this.onMouseMove);
        document.addEventListener("mouseup", this.onMouseUp);
    };

    onMouseMove = (event: MouseEvent) => {
        event.preventDefault();

        const distanceMoved = event.clientX - this.mouseX;
        this.mouseX = event.clientX;

        // shouldnt resize if mouse is to far to the left or right
        const boundingBox = this.resizeHandle.nativeElement.getBoundingClientRect();
        const rightSideX = boundingBox.x + boundingBox.width;

        if ((event.clientX < rightSideX && distanceMoved > 0) || (rightSideX < event.clientX && distanceMoved < 0)) return;

        this.nvdbNavigation.updateReportEditModalWidth(distanceMoved);
    };

    onMouseUp = (event: MouseEvent) => {
        document.body.style.removeProperty("cursor");

        this.container.nativeElement.style.removeProperty("user-select");
        this.container.nativeElement.style.removeProperty("pointer-events");

        this.resizeHandle.nativeElement.style.opacity = 0;

        // Attach the listeners to document
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.onMouseUp);

    };

    public menuToggle(): void {
        this.nvdbNavigation.toggleSideBar();
    }

    public goToMap() {
        this.router.navigate([this.nvdbNavigation.backLink]);
    }

    public goToMyPages() {
        this.router.navigate(["/home"]);
    }


    public onAfterCloseMyOptionsComponent(event: any): void { }



    public toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    }

    public selectLanguage(lang: string) {
        console.log('Selected language:', lang);
        if (lang === 'sv') {
            this.lang.setLanguage(Language.SV);
        } else if (lang === 'en') {
            this.lang.setLanguage(Language.ENG)
        }
        // Du kan lägga till språkväxlingslogik här
        this.dropdownOpen = false;
    }


    public showInfoComponent() {
        this.trvModalService.open(ApplicationInfoModalComponent, {
            disposeOnBackdropClick: true,
            size: this.nvdbNavigation.isMobileDevice ? "fullscreen" : "lg",
        });
    }

    public showReleaseNotesComponent() {
        this.trvModalService.open(ReleaseNotesComponent, {
            disposeOnBackdropClick: true,
            size: this.nvdbNavigation.isMobileDevice ? "fullscreen" : "lg",
        });
    }
}
